var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { setDefaultSettings } from '../../../store/actions/fuse/settings.actions';
import * as _ from 'lodash';
import { signOut } from '../../cognito/organizationApi';
export var SET_USER_DATA = '[USER] SET DATA';
export var SET_PROFILE_DATA = '[USER] SET PROFILE';
export var SET_USER_CONFIGURATION_DATA = '[USER] SET USER_CONFIGURATION';
export var REMOVE_USER_DATA = '[USER] REMOVE DATA';
export var USER_LOGGED_OUT = '[USER] LOGGED OUT';
export var USER_CHANGE_TOOLTIP_SETTINGS = '[USER] CHANGE TOOLTIP SETTINGS';
export var UPDATE_USER_AUTO_PLAY_SETTING = '[USER] UPDATE USER AUTO PLAY';
var isDevStage = window.location.href.indexOf('localhost') !== -1 ||
    window.location.href.indexOf(':3000') !== -1 ||
    window.location.href.indexOf('tt-react-dev') !== -1 ||
    window.location.href.indexOf('tt-react-test') !== -1 ||
    window.location.href.indexOf('.dev.trainingtube.com') !== -1;
export function setUserData(user, doNotUpdate) {
    return function (dispatch) {
        !doNotUpdate && user.role !== 'guest';
        dispatch(setDefaultSettings(user.settings));
        dispatch({
            type: SET_USER_DATA,
            payload: user,
        });
    };
}
export function setUserProfile(data) {
    return function (dispatch) {
        dispatch({
            type: SET_PROFILE_DATA,
            payload: data,
        });
    };
}
export function setUserConfigurationStatus(isCompleted) {
    return function (dispatch) {
        dispatch({
            type: SET_USER_CONFIGURATION_DATA,
            payload: { isCompleted: isCompleted },
        });
    };
}
export function updateUserAutoPlaySettingData(isAutoPlay) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_USER_AUTO_PLAY_SETTING,
            payload: isAutoPlay,
        });
    };
}
export function updateUserSettings(settings) {
    return function (dispatch, getState) {
        var oldUser = getState().auth.user;
        var user = _.merge({}, oldUser, { data: { settings: settings } });
        return dispatch(setUserData(user));
    };
}
export function toggleInShortcuts(id) {
    return function (dispatch, getState) {
        var user = getState().auth.user;
        var shortcuts = user.data.shortcuts;
        shortcuts = shortcuts.includes(id) ? shortcuts.filter(function (_id) { return id !== _id; }) : __spreadArray(__spreadArray([], shortcuts), [id]);
        return dispatch(setUserData(__assign(__assign({}, user), { data: __assign(__assign({}, user.data), { shortcuts: shortcuts }) })));
    };
}
export function removeUserData() {
    return {
        type: REMOVE_USER_DATA,
    };
}
export function changeTooltipSettings(tooltipDisabled) {
    return function (dispatch, getState) {
        return dispatch({
            type: USER_CHANGE_TOOLTIP_SETTINGS,
            payload: {
                tooltipDisabled: tooltipDisabled,
            },
        });
    };
}
export function logoutUser() {
    return function (dispatch, getState) {
        var state = getState();
        signOut();
        dispatch({
            type: USER_LOGGED_OUT,
        });
        var devParam = isDevStage ? '&isDev=true' : '';
        window.location.href =
            'https://www.trainingtube.com/login?redirectTo=' +
                window.location.href +
                '&commingFrom=' +
                state.auth.organization.domain +
                devParam +
                '&loggingOut=true';
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/actions/user.actions.ts
// module id = 57
// module chunks = 81